export default function PinIcon({ size = 14 }: { size?: number }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M16 3a1 1 0 0 1 .7 1.7L15.4 6l.9 5.2 2.4 2.4a1 1 0 0 1-.7 1.7H13v5.4a1 1 0 0 1-2 0v-5.4H6a1 1 0 0 1-.7-1.7l2.4-2.4.9-5.2-1.3-1.3A1 1 0 0 1 8 3h8Z" />
  </svg>;
}